import { ReactNode } from 'react';
import { type IntlShape } from 'react-intl';
import { ICONS } from '../../consts/consts';

type CommentType = {
  id: string;
  name?: string;
  pastTense?: string;
  icon?: string;
  textColor?: string;
};

export const COMMENT_TYPE_DEFAULT: CommentType = {
  id: 'D',
  // no name, as this is the default
};

export const COMMENT_TYPE_SUBMISSION = (
  formatMessage: IntlShape['formatMessage']
): CommentType => ({
  id: 'S',
  name: 'submission',
  pastTense: formatMessage({
    id: 'app.utils.models.comment.type.past.submitted',
    defaultMessage: 'submitted',
  }),
  icon: ICONS.PENDING,
  textColor: 'text-muted',
});

export const COMMENT_TYPE_APPROVAL = (
  formatMessage: IntlShape['formatMessage']
): CommentType => ({
  id: 'A',
  name: 'approval',
  pastTense: formatMessage({
    id: 'app.utils.models.comment.type.past.approved',
    defaultMessage: 'approved',
  }),
  icon: ICONS.APPROVED,
  textColor: 'text-success',
});

export const COMMENT_TYPE_DENIAL = (
  formatMessage: IntlShape['formatMessage']
): CommentType => ({
  id: 'E',
  name: 'denial',
  pastTense: formatMessage({
    id: 'app.utils.models.comment.type.past.denied',
    defaultMessage: 'denied',
  }),
  icon: ICONS.DENIED,
  textColor: 'text-danger',
});

export const COMMENT_TYPE_WITHDRAWAL = (
  formatMessage: IntlShape['formatMessage']
): CommentType => ({
  id: 'W',
  name: 'withdrawal',
  pastTense: formatMessage({
    id: 'app.utils.models.comment.type.past.withdrew',
    defaultMessage: 'withdrew',
  }),
  icon: ICONS.WITHDRAWN,
  textColor: 'text-muted',
});

export const COMMENT_TYPE_UNAPPROVAL = (
  formatMessage: IntlShape['formatMessage']
): CommentType => ({
  id: 'U',
  name: 'unapproval',
  pastTense: formatMessage({
    id: 'app.utils.models.comment.type.past.unapproved',
    defaultMessage: 'unapproved',
  }),
  icon: ICONS.PENDING,
  textColor: 'text-muted',
});

export const COMMENT_TYPE_UNDENIAL = (
  formatMessage: IntlShape['formatMessage']
): CommentType => ({
  id: 'N',
  name: 'undenial',
  pastTense: formatMessage({
    id: 'app.utils.models.comment.type.past.undenied',
    defaultMessage: 'undenied',
  }),
  icon: ICONS.PENDING,
  textColor: 'text-muted',
});

const commentTypes = (
  formatMessage: IntlShape['formatMessage']
): CommentType[] => [
  COMMENT_TYPE_DEFAULT,
  COMMENT_TYPE_SUBMISSION(formatMessage),
  COMMENT_TYPE_APPROVAL(formatMessage),
  COMMENT_TYPE_DENIAL(formatMessage),
  COMMENT_TYPE_WITHDRAWAL(formatMessage),
  COMMENT_TYPE_UNAPPROVAL(formatMessage),
  COMMENT_TYPE_UNDENIAL(formatMessage),
];

export const getCommentTypeText = (
  typeId: string,
  formatMessage: IntlShape['formatMessage']
): ReactNode | null => {
  const type = commentTypes(formatMessage).find((t) => t.id === typeId);

  if (!type || type.id === COMMENT_TYPE_DEFAULT.id) {
    return null;
  }
  return <span className={type.textColor}>{type.pastTense}</span>;
};
